import { isDemoClub } from "./demoClub";

/** Group CRUD permissions granted to demo club coaches and admins. */
export const DEMO_GROUP_PERMISSION_KEYS = [
  "VIEW_GROUP",
  "CREATE_GROUP",
  "UPDATE_GROUP",
  "DELETE_GROUP",
];

function readSignedInUser(user) {
  if (user && typeof user === "object") return user;
  try {
    const raw =
      typeof localStorage !== "undefined" ? localStorage.getItem("user") : null;
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
}

function isDemoClubStaff(user) {
  if (user.hasCoachRole || user.hasAdminRole) return true;
  const typeId = Number(user.type_user_id);
  if (typeId === 2 || typeId === 3) return true;
  const roles = Array.isArray(user.all_role_names) ? user.all_role_names : [];
  return roles.includes("Coach") || roles.includes("Admin");
}

/**
 * Demo club coaches and admins can manage groups (create, edit images, delete)
 * even when role permissions were not seeded on the environment.
 */
export function canManageDemoGroups(user = null) {
  const signedIn = readSignedInUser(user);
  if (!signedIn) return false;
  if (!isDemoClub(null, null, signedIn)) return false;
  return isDemoClubStaff(signedIn);
}

export function hasDemoGroupPermission(key, user = null) {
  if (!DEMO_GROUP_PERMISSION_KEYS.includes(key)) return false;
  return canManageDemoGroups(user);
}
